import { render } from "./CooperationEditorView.vue?vue&type=template&id=0583d9c2"
import script from "./CooperationEditorView.vue?vue&type=script&lang=js"
export * from "./CooperationEditorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__